module.exports = __webpack_public_path__ + "img/communication7.3462d240.png";